// Theme overlay for the latest seatmap redesign (SEATMAP_DESIGN.NEW).
//
// This is layered on top of `base` (via `extend`) only when the new design is
// active, so the default/legacy palette in base.js stays untouched for every
// other version and brand. Note: `extend` deep-merges only `seats`, `bags` and
// `seatmap`; other nested objects (baggageTrigger/seatMapTrigger) are replaced
// wholesale, so they are spelled out in full here.
const gray_15 = '#E2E8F0';

const seatmapRedesign = {
  textPrimary: '#111827',
  textSecondary: '#6B7280',
  title: '#111827',
  gray_10: '#F1F5F9',
  gray_15: gray_15,
  gray_20: '#CBD5E1',
  gray_50: '#94A3B8',
  gray_70: '#64748B',
  gray_100: '#334155',
  primary: '#111827',
  secondary: '#6B7280',
  link: '#2563EB',
  actionButtonBorderRadius: '12px',
  buttonBorderRadius: '12px',
  detailContainerDesktopBorderRadius: '12px',
  detailContainerDesktopBorder: '1px solid ' + gray_15,
  detailContainerMobileBorderRadius: '16px 16px 0 0',
  detailContainerMobileBorder: '0 solid ' + gray_15,
  legendBorderRadius: '8px',
  legendBorder: '1px solid ' + gray_15,
  alert: '#EF4444',
  warning: '#F59E0B',
  success: '#10B981',
  baggageTrigger: {
    upsellSummary: {
      enabled: false,
    },
    button: {
      background: '#2563EB',
    },
    border: '1px solid ' + gray_15,
    borderRadius: '12px',
    fontSize: '16px',
    fontFamily: 'Roboto, sans-serif',
    margin: '20px',
  },
  seatMapTrigger: {
    upsellSummary: {
      enabled: false,
    },
    button: {
      background: '#2563EB',
    },
    border: '1px solid ' + gray_15,
    borderRadius: '12px',
    fontSize: '16px',
    fontFamily: 'Roboto, sans-serif',
    margin: '20px',
  },
  seatmap: {
    background: '#F1F5F9',
  },
  seats: {
    1: {
      fill: '#E2E8F0',
      stopColor: '#CBD5E1',
      borderColor: 'transparent',
      labelColor: '#475569',
    },
    2: {
      fill: '#FF9EC4',
      stopColor: '#F07AA8',
      borderColor: 'transparent',
      labelColor: '#831843',
    },
    3: {
      fill: '#FDE68A',
      stopColor: '#FCD34D',
      borderColor: 'transparent',
      labelColor: '#78350F',
    },
    6: {
      fill: '#FED7AA',
      stopColor: '#FDBA74',
      borderColor: 'transparent',
      labelColor: '#7C2D12',
    },
    5: {
      fill: '#C7D2FE',
      stopColor: '#A5B4FC',
      borderColor: 'transparent',
      labelColor: '#312E81',
    },
    4: {
      fill: '#BBF7D0',
      stopColor: '#86EFAC',
      borderColor: 'transparent',
      labelColor: '#14532D',
    },
    0: {
      fill: '#BBF7D0',
      stopColor: '#86EFAC',
      borderColor: 'transparent',
      labelColor: '#14532D',
    },
    not_available: {
      fill: '#F1F5F9',
      stopColor: '#E2E8F0',
      borderColor: '#E2E8F0',
    },
    selected_seat: {
      fill: '#1D4ED8',
      stopColor: '#1E40AF',
      borderColor: 'transparent',
      labelColor: '#FFFFFF',
    },
  },
};

export default seatmapRedesign;
